<template>
    <div id="autologout_component"></div>
</template>

<script>
    import moment from 'moment'
    export default {
        data () {
            return {
                sessionCounter: ''
            }
        },
        beforeCreate () {
            let _this = this
            _this.$cookie.set('FTN_SESSION_TIME', 0)

            if (_this.$cookie.get('FTN_SESSION_START')) {
                let auth = _this.$store.getters.checkAuth

                if (auth) {
                    let then = _this.$cookie.get('FTN_SESSION_START'),
                        now  = moment().unix(),
                        diff = now - then

                    // If difference between dates is greater than 900 sec (15 min)
                    if (diff > 900) {
                        _this.$cookie.delete('FTN_SESSION_START')
                        _this.$router.push('/logout')
                    } else {
                        // Update time of session
                        let sessionTime = parseInt(_this.$cookie.get('FTN_SESSION_TIME')) + (diff * 1000)
                        _this.$cookie.set('FTN_SESSION_TIME', sessionTime)
                    }
                } else {
                    _this.$cookie.delete('FTN_SESSION_START')
                }
            } else {
                _this.$cookie.set('FTN_SESSION_START', moment().unix())
            }


            _this.sessionCounter = setInterval(function () {
                let auth = _this.$store.getters.checkAuth

                if (auth) {
                    let time = parseInt(_this.$cookie.get('FTN_SESSION_TIME')) + 1000

                    _this.$cookie.set('FTN_SESSION_TIME', time)

                    if (time >= 900000) {
                        _this.$store.commit('logoutUser')
                        window.location.reload()
                    }
                }
            }, 1000)
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/shared/autologout/Autologout.component.vue